import ImpresionQrPdfInsumos from "./ImpresionQrPdfInsumos";
import { Dialog, DialogContent, DialogTitle, Button, DialogActions, Typography } from "@mui/material";
import QrCode2Icon from "@mui/icons-material/QrCode2";

const ImpresionQRModalInsumos = ({ open, onClose }) => {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <QrCode2Icon sx={{ color: "#fff", fontSize: 22 }} />
        <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#fff", fontSize: "1rem" }}>
          Código QR — Habilitado
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <ImpresionQrPdfInsumos />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImpresionQRModalInsumos;
